import { render, staticRenderFns } from "./CurrentHandover.vue?vue&type=template&id=aad7b582"
import script from "./CurrentHandover.vue?vue&type=script&lang=js"
export * from "./CurrentHandover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports